<template>
    <div class="row">
        <nav class="navbar navbar-expand-lg  navbar-dark ">

            <div class="container">

                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main_navbar"
                    aria-controls="main_navbar" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="main_navbar">
                    <ul class="navbar-nav me-auto mb-2 mb-lg-0">

                        <li class="nav-item">
                            <a @click="RemoveClass() || ToHome()" class="nav-link active" aria-current="page" href="#">
                                <i class="bi bi-house-door"></i>
                            </a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link " @click=" RemoveClass() || ToAbout()" href="#">عن القطاع </a>
                        </li>
                        <li class="nav-item">
                            <a @click="  RemoveClass() || ToServices()" class="nav-link" href="#services">الخدمات</a>
                        </li>
                        <li class="nav-item">
                            <a @click=" RemoveClass() || ToIdealCenters()" class="nav-link" href="#">المراكز
                                النموذجية</a>
                        </li>
                        <li class="nav-item">
                            <a @click=" RemoveClass() || ToComplains()" class="nav-link" href="#"> أضف مقترح</a>
                        </li>
                        <li class="nav-item">
                            <a @click=" RemoveClass() || ToQuestions()" class="nav-link" href="#">الأسئلة الشائعة </a>
                        </li>
                        <li class="nav-item">
                            <a @click.prevent="RemoveClass() || ToInquiry()" class="nav-link" href="#"> إستعلام </a>
                        </li>

                        <li class="nav-item">
                            <a @click=" RemoveClass() || ToNews1()" class="nav-link" href="#"> الأخبار </a>
                        </li>

                        <li class="nav-item">
                            <a @click=" RemoveClass() || ToContactus()" class="nav-link" href="#"> اتصل بنا </a>
                        </li>

                    </ul>

                </div>
            </div>
        </nav>
    </div>


</template>

<script>
import jQuery from "jquery";
const $ = jQuery;
window.$ = $;
export default {
    name: 'NavComp',
    mounted() {
        $(window).scroll(function () {
            if ($(document).scrollTop() > 50) {

                $('nav').addClass('fixed-top', 20000, "easeInOutQuad");
            } else {
                $('nav').removeClass('fixed-top', 20000, "easeInOutQuad");
            }
        });
    },
    methods: {
        ToServices() {
            this.$router.push({ name: 'servicesdash' });
        },
        ToHome() {
            this.$router.push({ name: 'dashboard' })
        },
        ToNews1() {
            this.$router.push({ name: 'news1' })
        },
        ToAbout() {
            this.$router.push({ name: 'about' })
        },
        ToComplains() {
            this.$router.push({ name: 'complains' })
        },
        ToInquiry() {
            this.$router.push({ name: 'inquiry' })
        },
        ToQuestions() {
            this.$router.push({ name: 'questions' })
        },
        ToIdealCenters() {
            this.$router.push({ name: 'idealcenters' })
        },
        ToContactus() {
            this.$router.push({ name: 'contactus' })
        },
        RemoveClass() {
            document.querySelector(".navbar-collapse").classList.remove("show")
        },
    }


}


</script>